import styled from 'styled-components'

import { FlexCentered } from 'components/common/genericStyles'

import { tabDesktopBreakpoint } from '../constants'

export const Container = styled.div`
    ${FlexCentered}
    padding: 8px 16px;
    background: #ef5c34;
    border-radius: 40px;
    width: 40px;
    height: 40px;
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);

    @media only screen and (min-width: ${tabDesktopBreakpoint}px) {
        border-radius: 48px;
        width: 48px;
        height: 48px;
    }
`
